import { render, staticRenderFns } from "./ProjectsManagementEdit.vue?vue&type=template&id=4540da5f"
import script from "./ProjectsManagementEdit.vue?vue&type=script&lang=js"
export * from "./ProjectsManagementEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports